var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeLightBackward4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#222222",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13C27.1046 13 28 13.8954 28 15C28 16.1046 27.1046 17 26 17C24.8954 17 24 16.1046 24 15C24 13.8954 24.8954 13 26 13ZM26.75 18C27.4404 18 28 18.5596 28 19.25V25H23V21.75C23 19.6789 24.6789 18 26.75 18Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9964 15C12.7342 14.9978 12.4816 15.0986 12.293 15.2807L9.293 18.2807C9.10553 18.4682 9.00021 18.7225 9.00021 18.9877C9.00021 19.2529 9.10553 19.5072 9.293 19.6947L12.293 22.6947C12.3852 22.7902 12.4956 22.8664 12.6176 22.9188C12.7396 22.9712 12.8708 22.9988 13.0036 23C13.1364 23.0011 13.2681 22.9758 13.391 22.9255C13.5138 22.8753 13.6255 22.801 13.7194 22.7071C13.8133 22.6132 13.8875 22.5016 13.9378 22.3787C13.9881 22.2558 14.0134 22.1241 14.0123 21.9913C14.0111 21.8585 13.9835 21.7273 13.9311 21.6053C13.8787 21.4833 13.8025 21.373 13.707 21.2807L12.414 19.9877H17C17.2652 19.9877 17.5196 19.8824 17.7071 19.6948C17.8946 19.5073 18 19.2529 18 18.9877C18 18.7225 17.8946 18.4681 17.7071 18.2806C17.5196 18.0931 17.2652 17.9877 17 17.9877H12.414L13.707 16.6947C13.8892 16.5061 13.99 16.2535 13.9877 15.9913C13.9854 15.7291 13.8802 15.4783 13.6948 15.2929C13.5094 15.1075 13.2586 15.0023 12.9964 15Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLightBackward4);
export default __webpack_public_path__ + "static/media/we-light-backward-4.30dcf3d80d3d32888575940203466810.svg";
export { ForwardRef as ReactComponent };